/**
 * Affiliations Module
 */
 import Vue from 'vue';
 import router from '../../../router/router';
 import { apiModel, makeApiRequest } from "../../../api";
 import {store} from "../../store";
 
 // States
 const state = {
     assistantes: [],
     assistante: {}
 };
 
 // Getters
 const getters = {
     assistants: state => {
         return state.assistantes
     },
 
     assistante: state => {
         return state.assistante
     }
 };
 
 // Actions
 const actions = {
     getAssistantes(context, payload) {
         function successCallback(response) {
             context.commit('getAssistantsHandler', { assistantes: response.data.assistantes });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Assistante.List, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     getAssistante(context, payload) {
         function successCallback(response) {
             context.commit('getAssistanteHandler', { assistante: response.data.assistante });
         }
 
         function errorCallback(error) {
 
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Assistante.Get, localToken, successCallback, errorCallback, payload.errorMessages);
 
     },
 
     createAssistante(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
 
             router.push({ name: 'assistant', params: { assistant: response.data.assistante.slug } });
         }
 
         function errorCallback(error) {
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Assistante.Create, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     updateAssistante(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             store.dispatch('findAndRemove', {name: 'assistante' });
             router.push({ name: 'assistant', params: { assistant: response.data.assistante.slug } });
 
         }
 
         function errorCallback(error) {
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Assistante.Update, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     deleteAssistante(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             store.dispatch('findAndRemove', {name: 'assistant' });
             router.push({ name: 'assistants' });
 
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Assistante.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 };
 
 // Mutations
 const mutations = {
     getAssistantsHandler(state, { assistantes }) {
         // Update affiliations state
         state.assistantes = assistantes;
     },
 
     getAssistanteHandler(state, { assistante }) {
         // Update affiliation state
        //  console.log("assistante =>", assistante);
         state.assistante = assistante;
     },
 
 };
 
 export default {
     state,
     getters,
     actions,
     mutations
 }